export default __webpack_public_path__ + "static/media/spicycupcake@2x.d05c522f.jpg";